import styled from 'styled-components';
import WhiteRightSvg from '../../assets/hotels/arrow-right-white.svg';

const WHiteArrowRight = styled(WhiteRightSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '5rem'};
  height: ${props => props.height || '5rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default WHiteArrowRight;
